import React, { useCallback, useLayoutEffect, useState } from "react";
import { Button, Col, Container, Row, Dropdown, Form } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonSelect, CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import { useArchiveHomeEducationClientMutation, useDeleteHomeEducationClientMutation, useFavouriteEducationfClientMutation, useGetHomeEducationListQuery, useUpdateHomeEducationClientBudgetMutation, useUpdateHomeEducationStatusMutation } from "store/services/clients/homeEducation.client";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { convertToMomentDate, successMessageToast } from "helpers/common";
import { EDIT_HOME_EDUCATION } from "config/paths";
import { ArchiveIcon, CalendarIcon, DeleteIcon, EditIcon, UnArchiveIcon } from "Assets/icons";
import { useGetHomeEducationServiceListQuery } from "store/services/utility";
import TableRowInput from "components/shared/FormComponents/TableRowInput";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { homeEducationClientsFilter } from "store/slices/filter";
import ExportButton from "components/ExportButton";
import ExportConfirmModal from "components/Modals/ExportConfirmModal";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import { DownArrowIcon, ThreeDotsMenuIcon } from "Assets/icons/V2";
import { CLIENT_STATUS_OPTION, HOME_CLIENT_STATUS_OPTION } from "config/constants";
import { debounce } from "lodash";
import { Star } from "react-feather";

const HomeEducation = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const filter = useSelector(state => state?.filter?.homeEducationClientsFilter);
  const [newStatus, setNewStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = usePersistentState("home-ed:page", 1);
  const [pageSize, setPageSize] = useState(10);

  const [homeEducationList, setHomeEducationList] = useState([]);
  const { data: serviceList } = useGetHomeEducationServiceListQuery({});

  const [archiveClient, { isLoading: archiveClientLoading }] = useArchiveHomeEducationClientMutation();
  const [deleteClient, { isLoading: deleteClientLoading }] = useDeleteHomeEducationClientMutation();
  const [updateClient, { isLoading: updateClientLoading }] = useUpdateHomeEducationClientBudgetMutation();
  const [updateHomeEducationStatus, { isLoading: statusLoading }] = useUpdateHomeEducationStatusMutation()
  const [favouriteClient, { isLoading: favouriteClientLoading }] = useFavouriteEducationfClientMutation()

  const { data, isLoading, isError, isFetching } = useGetHomeEducationListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "archived", label: "Archive" },
    { value: "discharged", label: "Discharged" },
    { value: "incoming", label: "Incoming" },
  ];

  const sourceOptions = [
    { value: "internal", label: "Internal" },
    { value: "web", label: "Web" },
  ];

  const handleFavouriteReport = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      const response = await favouriteClient({ data, id }).unwrap()
      successMessageToast(response?.message)
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }

  const column = [
    {
      head: <div onClick={() => {
        handleFilterChange("sort")(filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "asc" } : { column: "is_favorite", direction: "desc" })
      }
      }>{filter?.sort?.column == "is_favorite" ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      component: (item, ind) => (
        <h6
          style={{ cursor: "pointer" }}
          className="m-0 text-capitalize cursor-pointer d-flex align-items-center gap-2">
          <div
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              console.log(item)
              handleFavouriteReport(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1)
            }}>
            {item?.client_detail?.is_favorite ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}
          </div>
        </h6>
      ),
    },
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.lastname}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.firstname}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "DOB",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{moment(item.client_detail?.dob, "YYYY-MM-DD").format("DD/MM/YYYY")}</h6>
      ),
    },
    {
      head: "Education Authority",
      accessor: "EducationAuthority",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.client_detail?.client_home_education_detail?.education_authority ?? "--"}</h6>
      ),
    },
    {
      head: "Date of intake",
      accessor: "intakeDate",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{convertToMomentDate(item.client_detail?.client_home_education_detail?.intake_date)}</h6>
      ),
    },
    {
      head: "Source",
      accessor: "source",
      isComponent: true,
      sorter: false,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.client_detail?.source}</h6>
      ),
    },
    // {
    //   head: "Initial Consultation",
    //   accessor: "InitialConsultation",
    // },
    // {
    //   head: "Service Assigned",
    //   accessor: "ServiceAssigned",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <div
    //       onClick={(e) => e.stopPropagation()}
    //     >
    //       <Dropdown onSelect={handleUpdate("service_assigned", item.id)}>
    //         <Dropdown.Toggle
    //           className="border-light text-dark w-100 fw-sbold"
    //           style={{ background: "#F3F3F3", height: 40, display: "flex" }}
    //           id="dropdown-basic"
    //         >
    //           <h6> {item?.client_detail?.client_home_education_detail?.serviceAssigned?.title || "Select Service"}{" "}</h6>
    //           <span className="icn ms-2">
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="10"
    //               height="5"
    //               viewBox="0 0 10 5"
    //               fill="none"
    //             >
    //               <path
    //                 d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
    //                 fill="#1C1B1F"
    //               />
    //             </svg>
    //           </span>
    //         </Dropdown.Toggle>
    //         <Dropdown.Menu
    //           className="w-100"
    //         >
    //           {
    //             serviceList?.map((item, index) => {
    //               return <Dropdown.Item key={index} eventKey={item.id}>{item?.title}</Dropdown.Item>
    //             })
    //           }
    //         </Dropdown.Menu>
    //       </Dropdown>
    //     </div >
    //   ),
    // },
    // {
    //   head: "Budget Assigned",
    //   accessor: "BudgetAssigned",
    //   isComponent: true,
    //   component: (item, ind) => (

    //     <div
    //       onClick={e => e.stopPropagation()}
    //     >
    //       <TableRowInput
    //         type="text"
    //         placeholder=""
    //         className="form-control"
    //         aria-label="Budget"
    //         defaultValue={((item.client_detail?.client_home_education_detail?.budget_assigned && item.client_detail?.client_home_education_detail?.budget_assigned != "null") ? parseFloat(item.client_detail?.client_home_education_detail?.budget_assigned) : 0)?.toFixed(2)}
    //         onSearchChange={(e) => handleUpdate("budget_assigned", item.id)(e || "0")}
    //         style={{ border: 0 }}
    //         maxLength={15}
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   head: "Status",
    //   accessor: "status",
    //   sorter: true,
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <p
    //       style={{ width: 80 }}
    //       className={`${item.status == "active"
    //         ? "greenStatus"
    //         : "redStatus"
    //         } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
    //     >
    //       {item.status}
    //     </p>
    //   ),
    // },
    {
      head: "Status",
      accessor: "status",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <div>
          <Dropdown
            onClick={(e) => e.stopPropagation()}
          >
            <Dropdown.Toggle
              variant="transparent"
              className="p-0 border-0 text-dark w-100 d-flex align-items-center gap-0"
              id="dropdown-basic"
            >
              <p
                style={{ width: 80, fontStyle: item?.status != "active" && "italic" }}
                className={`${item.status == "active"
                  && "greenStatus"
                  // : "redStatus"
                  } status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-2 py-1`}
              >
                {item.status}
              </p>
              <DownArrowIcon />

            </Dropdown.Toggle>

            <Dropdown.Menu className="" style={{ right: 0, left: "unset", minWidth: "150px" }}>
              <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                {statusOptions
                  .filter((status) =>
                    status.value != item.status
                  )
                  .map((status) => (
                    <h5
                      key={status.value}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentEntry(item);
                        setModalType(status?.value === "archived" ? "archive" : status?.value);
                        setNewStatus(status?.value)
                        setShowModal(true)
                      }}
                      className="cursor-pointer proxima mb-2"
                    >
                      {status.label}
                    </h5>
                  ))
                }
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Dropdown
            onClick={(e) => e.stopPropagation()}
          // show={index == dropdownIndex}
          // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
          >
            <Dropdown.Toggle
              variant="transparent"
              className="p-0 border-0 text-dark w-100"
              id="dropdown-basic"
            >
              <ThreeDotsMenuIcon />
            </Dropdown.Toggle>

            <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
              <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                <h5 onClick={(e) => {

                  e.stopPropagation();
                  navigate(EDIT_HOME_EDUCATION.replace(":id", item.id))
                }} className="cursor-pointer proxima mb-2">
                  Edit
                </h5>

                <h5 onClick={(e) => {

                  e.stopPropagation();
                  setCurrentEntry(item);
                  setModalType("delete")
                  setShowModal(true);
                }}
                  className="cursor-pointer proxima mb-2">
                  Delete
                </h5>
              </ul>
            </Dropdown.Menu>
          </Dropdown>

        </div >
      ),
    },

  ];

  const resetFilter = () => {
    dispatch(homeEducationClientsFilter({ search: "", division: "", school: "", status: "active", sort: { column: "lastname", direction: "asc" } }));
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(homeEducationClientsFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearchChange = useCallback(debounce((value, key = "") => {
    setCurrentPage(1);
    handleFilterChange(key)(value);
  }, 500), [handleFilterChange, 500]);

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const list = [...homeEducationList];
      const index = homeEducationList?.findIndex(x => x.id === currentEntry?.id);
      delete list[index];
      setHomeEducationList(list.filter(Boolean))

      const result = await deleteClient(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error archiving discipline", err);
    };
  };

  const handleArchive = async () => {
    try {

      setShowModal(false);

      const list = [...homeEducationList];
      const index = homeEducationList?.findIndex(x => x.id === currentEntry?.id);
      list[index] = { ...list[index], status: list[index].status == "active" ? "archived" : "active" };
      setHomeEducationList(list.filter(Boolean))

      const result = await archiveClient(currentEntry?.id);
      if (!result?.error) successMessageToast("Record has been updated successfully.");

    } catch (err) {
      console.error("error archiving home education", err);
    };
  };

  const handleUpdate = (key, id) => async (value) => {

    const data = { [key]: value };
    const result = await updateClient({ data, clientId: id });

    if (result?.error) console.error("Error creating School Client", result.error);
    else successMessageToast(result?.data?.message);
  };

  const handleUpdateStatus = async () => {
    setShowModal(false)
    try {
      const resp = await updateHomeEducationStatus({
        clientId: currentEntry?.id,
        status: newStatus
      });
      if (resp.data.status === "success") {
        successMessageToast(resp?.data?.message)
      }

    } catch (error) {
      console.error(error);
    }
  }

  useLayoutEffect(() => {

    if (data?.records) setHomeEducationList(data?.records)
  }, [data]);
  console.log(":filter", filter)

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={modalType == "delete" ? handleDelete : handleUpdateStatus}
        type={modalType}
      >

      </ConfirmationPop >
      {" "}
      <section className="client position-relative py-4">
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left classroom-conslutation">
                  <h6 className="m-0 fw-bold main-head themeBlue">Home Education</h6>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Link to={`/client/home-education/add`} className="blue-discharge-screen-btn mt-0 d-flex align-items-center justify-content-center">
                        Add a Client
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="12" className="my-2">
              {/* <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    heading={"Home Education"}
                    handleFilterChange={handleFilterChange}
                    filter={filter}
                    resetFilter={resetFilter}
                    searchPlaceholder="Client Last, First Name"
                    filterComponent={
                      <>
                        <li>
                          <DatePicker
                            className="form-control forteen filter-datepicker"
                            placeholderText="Start Date"
                            selectsStart
                            icon={<CalendarIcon />}
                            showIcon
                            value={filter?.startDate ? moment(filter?.startDate).format("DD-MM-YYYY") : ""}
                            onChange={(e) => handleFilterChange("startDate")(moment(e).format("YYYY-MM-DD"))}
                          />
                        </li>
                        <li>
                          <DatePicker
                            className="form-control forteen filter-datepicker"
                            placeholderText="End Date"
                            selectsEnd
                            icon={<CalendarIcon />}
                            showIcon
                            value={filter?.endDate ? moment(filter?.endDate).format("DD-MM-YYYY") : ""}
                            onChange={(e) => handleFilterChange("endDate")(moment(e).format("YYYY-MM-DD"))}
                          />
                        </li>
                      </>
                    }
                  />

                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <ExportButton
                        module={"client_home_education"}
                        filter={filter}
                      />
                    </li>
                    <li className="">
                      <Link
                        to="/client/home-education/add"
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                      >
                        <span className="icn me-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_0_4440"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="19"
                              height="19"
                            >
                              <rect
                                width="18.7197"
                                height="18.7197"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_0_4440)">
                              <path
                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>{" "}
                        Add New Clients
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}

              <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
                <Col sm="4" md='2'>
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Start Date</label>
                    <DatePicker
                      className="form-control"
                      placeholderText="Start Date"
                      selectsStart
                      icon={<CalendarIcon />}
                      showIcon={filter?.startDate ? false : true}
                      isClearable={filter?.startDate ? true : false}
                      selected={filter?.startDate ? new Date(filter.startDate) : null}
                      onChange={(date) =>
                        handleFilterChange("startDate")(
                          date ? moment(date).format("YYYY-MM-DD") : ""
                        )
                      }
                    />
                  </div>
                </Col>
                <Col sm="4" md='2'>
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">End Date</label>
                    <DatePicker
                      className="form-control"
                      placeholderText="End Date"
                      selectsEnd
                      icon={<CalendarIcon />}
                      showIcon={filter?.endDate ? false : true}
                      isClearable={filter?.endDate ? true : false}
                      selected={filter?.endDate ? new Date(filter.endDate) : null}
                      onChange={(date) =>
                        handleFilterChange("endDate")(
                          date ? moment(date).format("YYYY-MM-DD") : ""
                        )
                      }
                    />
                  </div>
                </Col>
                <Col sm="4" md='2'>
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Status</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={HOME_CLIENT_STATUS_OPTION}
                      onChange={(e) => handleFilterChange("status")(e)}
                      value={filter?.status}
                      isFilterV2
                      // isClearable
                      // isLoading={schoolListLoading || schoolListFetching}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    />
                  </div>
                </Col>
                <Col sm="4" md='2'>
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Source</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={sourceOptions}
                      onChange={(e) => handleFilterChange("source")(e)}
                      value={filter?.source}
                      isFilterV2
                      isClearable
                      // isLoading={schoolListLoading || schoolListFetching}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    />
                  </div>
                </Col>
                <Col sm="6" md="2" className="mt-3 mt-md-0">
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Search Education Authority</label>
                    <input
                      onChange={(e) => handleSearchChange(e.target.value, "education_authority")}
                      // style={{outline: "blue"}}
                      className={`input-new readonly-box h-auto search-input-filter-v2`}
                      placeholder="Find a client..."
                      defaultValue={filter?.education_authority}
                    />
                  </div>
                </Col>
                <Col sm="6" md="2" className="mt-3 mt-md-0" style={{ borderLeft: "1px solid #315D99" }}>
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Search</label>
                    <input
                      onChange={(e) => handleSearchChange(e.target.value, "search")}
                      // style={{outline: "blue"}}
                      className={`input-new readonly-box h-auto search-input-filter-v2`}
                      placeholder="Find a client..."
                      defaultValue={filter?.search}
                    />
                  </div>
                </Col>


              </Row>

              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || updateClientLoading || archiveClientLoading || deleteClientLoading || favouriteClientLoading) && <LoadingOverlay />}
                    {/* <TableLayout
                      data={homeEducationList}
                      column={column}
                      url={"/client/home-education/detail"}
                      handleSort={handleFilterChange("sort")}
                      filter={filter}
                    /> */}
                    <TableLayoutV2
                      data={homeEducationList}
                      column={column}
                      url={"/client/home-education/detail"}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  className="paginationV2"
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default HomeEducation;

